<template>
    <div>
    	<header-component />

    	<!-- begin::Body -->
		<div class="m-grid m-grid--ver-desktop m-grid--desktop m-page__container m-body">
            <aside-component />
    		<router-view/>
		</div>
		<!-- end::Body -->

		<change-password-form />

    	<footer-component />	
    </div>
</template>

<script>

	import Header from "../components/Header";
    import Aside from "../components/Aside";
	import Footer from "../components/Footer";
	import ChangePassword from "../components/ChangePassword";

    export default {
		data() {
            return {
				
            }
        },

        created(){
        	this.$store.dispatch('fetchUserInfo');
        	this.$store.dispatch('fetchUserBudget');
        	this.$store.dispatch('fetchChannelInfo');
        	this.$store.dispatch('fetchGameInfo');
            this.$store.dispatch('fetchPropInfo');
            this.$store.dispatch('fetchXienChannelInfo');
        	this.$store.dispatch('fetchChannelTodayInfo');
        },

        mounted() {
        	$("body").attr("class", "m-page--fluid m-page--loading-enabled m-header--fixed-mobile m-aside-left--enabled");
        	let logo = require('../assets/img/bg/bg-7.jpg');
        	$("body").attr("style", "background-image: url("+logo+");");

        	//mLayoutfrom metronic framework
        	mLayout.init();
        	$('#m_aside_header_topbar_mobile_toggle').off('click').click(function() {
        		let b = $('body');
        		if(b.hasClass('m-topbar--on')){
        			b.removeClass('m-topbar--on');
        			window.setTimeout(()=>{ b.removeClass('m-topbar--on'); }, 200);
        		}else{
        			b.addClass('m-topbar--on');
        			window.setTimeout(()=>{ b.addClass('m-topbar--on'); }, 200);
        		}
	        });

        	this.$router.push({name:"UserInfo"});
        },

        components: {
			'header-component': Header,
            'aside-component': Aside,
			'footer-component': Footer,
			'change-password-form': ChangePassword
	    }
	}
</script>

<style>
    .error {
		text-align: center;
		color: red;
		font-size: medium;
    }
</style>